import { messages as englishMessages } from "./en";
import { messages as swahiliMessages } from "./sw";

const messages = {
  ...englishMessages,
  ...swahiliMessages,
};

export { messages };
